admin.charity = {
  addDonationPrice: function (link, association, content) {
    var new_id = new Date().getTime(),
      regexp = new RegExp("new_" + association, "g");
    $("#edit-charity-prices").append(content.replace(regexp, new_id));
    $("#charity_donation_prices_attributes_" + new_id + "_price").focus();
  },

  addDonationReason: function (link, association, content) {
    var new_id = new Date().getTime(),
      regexp = new RegExp("new_" + association, "g");
    $("#edit-charity-reasons").append(content.replace(regexp, new_id));
    $("#charity_donation_reasons_attributes_" + new_id + "_name").focus();
  },

  removeDonationPrice: function (link) {
    $(link).prev("input[type=hidden]").val("1");
    $(link).closest(".fields").hide();
  },

  removeDonationReason: function (link) {
    $(link).prev("input[type=hidden]").val("1");
    $(link).closest(".fields").hide();
  },
};
